import i18n from '@/locales'
import { getWorkflowParamter } from '@/utils/utils'
import { WORKFLOW_TYPES } from '@/constants/workflow'
import WorkflowMixin from '@/mixins/workflow'
export default {
  mixins: [WorkflowMixin],
  created () {
    this.singleActions = [
      {
        label: i18n.t('common_403'),
        action: obj => {
          this.createDialog('WorkflowRevokeDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            success: () => {
              this.refresh()
            },
          })
        },
        meta: (obj) => {
          return {
            validate: obj.state !== 'COMPLETED' && obj.state !== 'EXTERNALLY_TERMINATED' && obj.variables.can_terminate_status !== false,
          }
        },
      },
      {
        label: i18n.t('common.edit'),
        action: obj => {
          if (obj.process_definition_key === 'apply-machine') {
            const { variables } = obj
            const server_create_paramter = variables['server-create-paramter'] || variables.paramter
            const data = JSON.parse(server_create_paramter)
            if (data.extraData?.__resource_type__ === 'baremetal') {
              this.$router.push({
                name: 'BaremetalCreate',
                query: {
                  type: data.extraData.formType,
                  workflow: obj.id,
                },
                params: {
                  data,
                },
              })
            } else {
              this.$router.push({
                name: 'VMInstanceCreate',
                query: {
                  type: data.extraData.formType,
                  workflow: obj.id,
                },
                params: {
                  data,
                },
              })
            }
          } else if (obj.process_definition_key === 'apply-server-changeconfig') {
            const serverConf = JSON.parse(obj.variables.serverConf)
            this.$router.push({
              name: 'VMInstanceAdjustConfig',
              query: {
                workflow: obj.id,
                id: obj.variables.ids.split(','),
              },
              params: {
                data: serverConf,
              },
            })
          } else if (obj.process_definition_key === 'apply-server-stop') {
            this.createDialog('VmShutDownDialog', {
              ids: obj.variables.ids.split(','),
              type: 'modifyWorkflow',
              workflow: obj.id,
              formData: { ...JSON.parse(obj.variables.paramter), reason: obj.variables?.description },
              name: this.$t('system.text_12'),
              success: () => {
                if (this.refresh) {
                  this.refresh()
                }
                if (this.list?.singleRefresh) {
                  this.list.singleRefresh(obj.id)
                }
                if (this.initProcessHistorys) {
                  this.initProcessHistorys()
                }
              },
            })
          } else if (obj.process_definition_key === 'apply-server-start') {
            this.createDialog('VmStartDialog', {
              type: 'modifyWorkflow',
              ids: obj.variables.ids.split(','),
              workflow: obj.id,
              formData: { ...JSON.parse(obj.variables.paramter), reason: obj.variables?.description },
              name: this.$t('system.text_12'),
              success: () => {
                if (this.refresh) {
                  this.refresh()
                }
                if (this.list?.singleRefresh) {
                  this.list.singleRefresh(obj.id)
                }
              },
            })
          } else if (obj.process_definition_key === 'apply-server-restart') {
            this.createDialog('VmRestartDialog', {
              type: 'modifyWorkflow',
              workflow: obj.id,
              ids: obj.variables.ids.split(','),
              formData: { ...JSON.parse(obj.variables?.paramter), reason: obj.variables?.description },
              name: this.$t('system.text_12'),
              success: () => {
                if (this.refresh) {
                  this.refresh()
                }
                if (this.list?.singleRefresh) {
                  this.list.singleRefresh(obj.id)
                }
              },
            })
          } else if (obj.process_definition_key === 'apply-server-delete') {
            this.createDialog('DeleteVmDialog', {
              type: 'modifyWorkflow',
              workflow: obj.id,
              ids: obj.variables.ids.split(','),
              formData: { ...JSON.parse(obj.variables?.paramter), reason: obj.variables?.description },
              name: this.$t('system.text_12'),
              success: () => {
                if (this.refresh) {
                  this.refresh()
                }
                if (this.list?.singleRefresh) {
                  this.list.singleRefresh(obj.id)
                }
              },
            })
          } else if (obj.process_definition_key === 'apply-join-project') {
            this.createDialog('ApplyJoinProjectDialog', {
              type: 'modifyWorkflow',
              workflow: obj.id,
              formData: { description: obj.variables?.description },
              name: this.$t('system.text_12'),
              success: () => {
                if (this.refresh) {
                  this.refresh()
                }
                if (this.list?.singleRefresh) {
                  this.list.singleRefresh(obj.id)
                }
              },
            })
          } else if (obj.process_definition_key === 'execute-resource-order-set') {
            this.handleOpenSidepage(obj)
          }
        },
        meta: (obj) => {
          const ret = { validate: true }
          if (obj.state !== 'ACTIVE' || obj.variables.audit_status) {
            ret.validate = false
            ret.tooltip = this.$t('common.workflow_disabled_tip2')
          }
          if (!this.isOpenWorkflow(obj.process_definition_key)) {
            ret.validate = false
            ret.tooltip = this.$t('common.workflow_disabled_tip3')
          }
          if (![WORKFLOW_TYPES.APPLY_JOIN_PROJECT, WORKFLOW_TYPES.APPLY_MACHINE, WORKFLOW_TYPES.APPLY_SERVER_CHANGECONFIG, WORKFLOW_TYPES.APPLY_SERVER_DELETE, WORKFLOW_TYPES.APPLY_SERVER_STOP, WORKFLOW_TYPES.APPLY_SERVER_RESTART, WORKFLOW_TYPES.APPLY_SERVER_START, WORKFLOW_TYPES.EXECUTE_RESOURCE_ORDER_SET].includes(obj.process_definition_key)) {
            ret.validate = false
            ret.tooltip = this.$t('common.workflow_disabled_tip')
          }
          return ret
        },
        hidden: (obj) => {
          if (obj.process_definition_key === 'execute-resource-order-set' && !this.handleOpenSidepage) {
            return true
          }
          return false
        },
      },
      {
        label: i18n.t('common.clone'),
        action: obj => {
          this.createDialog('WorkflowCloneDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            success: () => {
              this.refresh()
            },
          })
        },
        meta: (obj) => {
          const ret = { validate: true }
          if (!this.isOpenWorkflow(obj.process_definition_key)) {
            ret.validate = false
            ret.tooltip = this.$t('common.workflow_disabled_tip3')
          }
          return ret
        },
      },
      {
        label: i18n.t('wz_workflow_form.actions.re_apply'),
        action: obj => {
          const form = getWorkflowParamter(obj.variables)
          let data = {}
          if (form.unitInfo) {
            data = form
          }
          this.$router.push({
            name: 'WorkflowApplyInternalResourceCreate',
            params: {
              formData: data,
            },
          })
        },
        hidden: (obj) => {
          return !((obj.variables.audit_status === 'refused' || obj.state === 'EXTERNALLY_TERMINATED') && obj.process_definition_key === 'apply-internal-resource')
        },
      },
    ]
  },
  methods: {
    isOpenWorkflow (process_definition_key) {
      return this.checkWorkflowEnabled(process_definition_key)
    },
  },
}
